import { render, staticRenderFns } from "./HarvestReminders.vue?vue&type=template&id=16baea2b"
import script from "./HarvestReminders.vue?vue&type=script&lang=js"
export * from "./HarvestReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports